import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DatasourceListComponent } from './datasource/datasource-list/datasource-list.component';
import {LoginComponent } from './login/login.component';


const routes: Routes = [  
  { path: '', component: LoginComponent },  
  { path: 'brokerlist', component: DatasourceListComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
